import { Link } from "react-router-dom";

import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const LinkBack = styled(Link)`
    ${Fonts.Heading.H700};
    cursor: pointer;
    color: ${Colors.Black.V50};
`;
